
/**
 * x
 * @param date1 xx
 * @param date2 x
 */
export default function diffYears(date1: Date, date2: Date): number {
  if (!date1 || !date2) return 0;
  if (isNaN(date1.getTime()) || isNaN(date2.getTime())) return 0;
  return Math.abs(date1.getFullYear() - date2.getFullYear());
}

